import React from 'react';
import { Hero } from '../components/Hero';
import { ThePractice } from '../components/ThePractice';
import { VeraReserve } from '../components/VeraReserve';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { Questions } from '../components/Questions';
import { OtherTiers } from '../components/OtherTiers';
import { SelectedVoices } from '../components/SelectedVoices';
import { Ashley } from '../components/Ashley';
import { Application } from '../components/Application';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full bg-cream min-h-screen selection:bg-brass selection:text-cream" data-id="element-130" data-mp="24ivabb6zunaw">
      <Hero data-id="element-131" data-mp="29ihpvraaofmv" />
      <ThePractice data-id="element-132" data-mp="2dhqk0x98yfiy" />
      <VeraReserve data-id="element-133" data-mp="2di8djm4iyfn6" />
      <WhatsIncluded data-id="element-134" data-mp="2dirxf8dqje3u" />
      <Questions data-id="element-135" data-mp="2dj1lurj4td7f" />
      <OtherTiers data-id="element-136" data-mp="2dfdsbsdosqsp" />
      <SelectedVoices data-id="element-137" data-mp="3kvk4whwqwx4x" />
      <Ashley data-id="element-138" data-mp="3kw21xgr8ffdw" />
      <Application data-id="element-139" data-mp="3kuiixie6yq8f" />
      <Footer data-id="element-140" data-mp="3kv0k8tfpnun7" />
    </main>;
}